// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ZhihuOutlinedSvg from "@ant-design/icons-svg/es/asn/ZhihuOutlined";
import AntdIcon from '../components/AntdIcon';

var ZhihuOutlined = function ZhihuOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ZhihuOutlinedSvg
  }));
};

ZhihuOutlined.displayName = 'ZhihuOutlined';
export default React.forwardRef(ZhihuOutlined);